export default __webpack_public_path__ + "static/cups-536aebfcf4d3e2e2297c6e089d101e55.png";